import { useQuery } from '@tanstack/react-query';

import { createClient } from 'contentful';

import { getConfig } from '../../../utils/getConfig.ts';
import { HelpDrawerDocSkeleton, PageID } from './types.ts';

const client = createClient({
  space: getConfig('CONTENTFUL_SPACE_ID'),
  accessToken: getConfig('CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN'),
});

const getEntries = async (pageID: PageID | null) =>
  client
    .getEntries<HelpDrawerDocSkeleton>({
      content_type: 'helpDrawerDocument',
      limit: 1,
      'fields.pageId[match]': pageID ?? undefined,
    })
    .then(({ items }) => items);

export const useHelpDrawerDoc = ({ pageID }: { pageID: PageID | null }) => {
  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['helpDrawerDoc', pageID],
    queryFn: () => getEntries(pageID),
    enabled: !!pageID,
  });

  return { document: data[0] ?? null, isLoading, isError, error };
};
